import { officeSearchForSlug } from '@/lib/officeSearch'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_contractor/$tenantSlug/')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/quotes', search: officeSearchForSlug(params.tenantSlug) })
  },
})
